import React, { PureComponent } from "react";
import { Creatable } from "react-select";

import FrontierSlidersContainer from "containers/FrontierSliders/FrontierSliders";
import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import OptimizeBy from "containers/Project/OptimizeBy";

import ConditionListInput from "components/UnifiedProject/SelectData/ConditionListInput";
import UniqueIdColumnInput from "components/UnifiedProject/SelectData/UniqueIdColumnInput";

import { Button, ButtonGroup } from "aible";

import styles from "./style.module.css";
import { isEnabled } from "utils/featureFlags";

import ProjectBounds from "components/Project/ProjectBounds";

export default class AdvancedDeploy extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      adjustments: "ALLOW",
      isUpdatingMonitorSettings: false,
      changesSaved: false
    };
  }
  render() {
    const {
      project,
      isNext,
      terminalConditions,
      updateTerminalConditions,
      activityConditions,
      updateActivityConditions,
      optimized,
      uniqueId,
      businessPredictionName,
      updateUniqueId,
      updateBusinessPredictionName,
      selectedDataset,
      setFrontierPercentProcessed,
      handleUpdateMonitorSettings,
      isScenarioDeployed
    } = this.props;

    const { adjustments } = this.state;

    const outcome = optimized.dataset && optimized.dataset.outcome;

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    const isContinuousOutcome = optimized?.dataset?.fields[optimized?.dataset?.outcome]?.type === "number";

    const onMonitoringSettingsButtonClick = () => {
      this.setState({ isUpdatingMonitorSettings: true }, () => {
        handleUpdateMonitorSettings().then(() => {
          this.setState({
            isUpdatingMonitorSettings: false,
            changesSaved: true
          });
        });
      });
    };

    const updateChangesSaved = () => {
      if (this.state.changesSaved) {
        this.setState({ changesSaved: false });
      }
    };

    return (
      <div className={styles.deploy} style={{ height: "unset" }}>
        {isNext !== true && (
          <div className={styles.deployHeader} style={{ fontSize: "24px", marginBottom: "40px" }}>
            {"Model Deployment: Advanced Options"}
          </div>
        )}

        <div>
          <div className={styles.deployHeader}>{"Additional Model Optimization"}</div>
          <div className={styles.deploySubHeader} style={{ marginBottom: "40px" }}>
            {"You have selected a scenario that is within your frontier. " +
              "Aible does not need to retrain models to deploy this scenario."}
          </div>
        </div>
        {isEnabled("optimize-by") && (
          <OptimizeBy
            {...this.props}
            onClick={() => {
              updateChangesSaved();
            }}
          />
        )}
        {isContinuousOutcome && <ProjectBounds projectId={project.id} updateChangesSaved={updateChangesSaved} />}
        {!isNext && (
          <div style={{ marginBottom: "40px" }}>
            <div className={styles.deployHeader}>{"Aible for One Customization"}</div>
            <div className={styles.deploySubHeader}>
              {"How would you like Aible for One users to interact with the deployed model frontiers?"}
            </div>
            <div className={styles.deployButtons}>
              {isContinuous ? (
                <i>{"Coming soon for continuous outcomes"}</i>
              ) : (
                <ButtonGroup style={{ marginBottom: "10px" }}>
                  <Button
                    active={adjustments === "NONE"}
                    onClick={() => {
                      setFrontierPercentProcessed([1, 0]);
                      return this.setState({ adjustments: "NONE" });
                    }}
                  >
                    {"No Adjustments"}
                  </Button>
                  <Button
                    active={adjustments === "ALLOW"}
                    onClick={() => {
                      setFrontierPercentProcessed([0, 1]);
                      return this.setState({ adjustments: "ALLOW" });
                    }}
                  >
                    {"Allow Adjustments"}
                  </Button>
                  <Button
                    active={adjustments === "CUSTOM"}
                    onClick={() => {
                      setFrontierPercentProcessed(undefined, true);
                      this.setState({ adjustments: "CUSTOM" });
                    }}
                  >
                    {"Custom"}
                  </Button>
                </ButtonGroup>
              )}
              <div>
                {adjustments === "CUSTOM" ? (
                  <FrontierSlidersContainer
                    hideHeader
                    constrainAibleForOne
                    overrideSliderView={FRONTIER_SLIDERS_VIEW.SELECTED}
                    id={project && project.id}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        )}
        <div style={{ marginBottom: "40px" }}>
          <div className={styles.deployHeader}>{"Terminal State"}</div>
          <div className={styles.deploySubHeader} style={{ marginBottom: "20px" }}>
            {"Please specify the conditions under which the variable " +
              outcome +
              " is finally known and thus the AI can retrain based on whether or not it predicted " +
              outcome +
              " correctly."}
          </div>
          <div className={styles.optionsSelect}>
            <ConditionListInput
              dataset={selectedDataset}
              conditions={terminalConditions}
              onChange={(conditions) => {
                updateTerminalConditions(conditions);
                updateChangesSaved();
              }}
            />
          </div>
        </div>
        <div>
          <div className={styles.deployHeader}>{"Unique Identifier"}</div>
          <div className={styles.deploySubHeader} style={{ marginBottom: "20px" }}>
            {"Please specify what column, if any, represents a unique identifier in your dataset. " +
              "This allows us to remove duplicate information when showing monitoring results."}
          </div>
          <div className={styles.optionsSelect} style={{ marginBottom: "40px" }}>
            <UniqueIdColumnInput
              dataset={selectedDataset}
              uniqueIdColumn={uniqueId}
              onChange={(value) => {
                updateUniqueId(value);
                updateChangesSaved();
              }}
            />
          </div>
        </div>
        {isEnabled("user-compliance") && (
          <div>
            <div className={styles.deployHeader}>{"User Analytics"}</div>
            <div className={styles.deploySubHeader} style={{ marginBottom: "20px" }}>
              {isContinuous
                ? "Would you like to monitor whether your users are following the AI recommendations? Please specify what column, if any, represents the action the user intends to take."
                : "Would you like to monitor whether your users are following the recommendations. Please define a rule that specifies whether a user acted upon a transaction."}
            </div>
            <div className={styles.optionsSelect} style={{ marginBottom: "40px" }}>
              {isContinuous ? (
                <Creatable
                  value={
                    businessPredictionName
                      ? {
                          label: businessPredictionName,
                          value: businessPredictionName
                        }
                      : null
                  }
                  onChange={({ value }) => {
                    updateBusinessPredictionName(value);
                    updateChangesSaved();
                  }}
                  options={
                    selectedDataset && selectedDataset.fields
                      ? Object.values(selectedDataset.fields).map(({ label }) => ({
                          label: label,
                          value: label
                        }))
                      : []
                  }
                  className={styles.outcomePicker}
                  placeholder="Select Value"
                  menuPlacement="top"
                />
              ) : (
                <ConditionListInput
                  dataset={selectedDataset}
                  conditions={activityConditions}
                  onChange={(conditions) => {
                    updateActivityConditions(conditions);
                    updateChangesSaved();
                  }}
                />
              )}
            </div>
          </div>
        )}
        <div>
          <Button
            disabled={!isScenarioDeployed || this.state.isUpdatingMonitorSettings || this.state.changesSaved}
            onClick={() => {
              onMonitoringSettingsButtonClick();
            }}
            type={"primary"}
          >
            {!isScenarioDeployed
              ? "Scenario Not Deployed"
              : this.state.isUpdatingMonitorSettings
                ? `Saving Deployment Settings...`
                : this.state.changesSaved
                  ? `Settings Saved Successfully`
                  : `Update Deployment Settings`}
          </Button>
        </div>
      </div>
    );
  }
}
